import { useLocalization } from "@/context/localization-context";
import { cn } from "@/lib/utils";
import type { BbKind, BbStep } from "../../types";
import { Chip } from "../pipeline/shared";
import { outcomeLabel, outcomeTone, stepsText } from "./helpers";

/** Small building blocks of the BiteBerry tab. */

export function OutcomeChip({ outcome, className }: { outcome: string | null | undefined; className?: string }) {
  return (
    <Chip tone={outcomeTone(outcome)} className={cn("font-mono", className)} title={outcome ?? undefined}>
      {outcomeLabel(outcome)}
    </Chip>
  );
}

export function KindChip({ kind, className }: { kind: BbKind; className?: string }) {
  const { t } = useLocalization();
  return (
    <span
      className={cn(
        "inline-flex h-5 w-[4.75rem] shrink-0 items-center justify-center rounded bg-muted/60 px-1.5 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground",
        className,
      )}
    >
      {t(`monitoring.bb.kind.${kind}`)}
    </span>
  );
}

/** BiteBerry preparation steps with what is left, packing done highlighted. */
export function StepsLine({ steps, className }: { steps: BbStep[] | null | undefined; className?: string }) {
  if (!steps?.length) return <span className={cn("text-muted-foreground", className)}>–</span>;
  return (
    <span className={cn("inline-flex flex-wrap gap-x-2 gap-y-0.5 font-mono text-[11px]", className)} title={stepsText(steps)}>
      {steps.map((step, i) => (
        <span
          key={`${step.name}-${i}`}
          className={cn(step.quantity_left === 0 ? "text-foreground" : "text-muted-foreground")}
        >
          {step.name ?? "?"} <span className="tabular-nums">{step.quantity_left ?? "?"}</span>
        </span>
      ))}
    </span>
  );
}
